/* eslint-disable max-len */
import React from 'react';
import './style.css';
/* import './bootstrap.min.css'; */

function ShippingPolicy() {
    return (
        <div className='policy'>
            <nav className="relative flex flex-wrap items-center content-between py-3 px-4 top-0 ">
                <a href="https://www.adorwelding.com/" target="_blank" rel="noreferrer">
                    <img src="/images/Group8786.png" alt="icon" />
                </a>
            </nav>
            <div>
                <section className="sub-page-banner">
                    <div className='w-full flex items-center xl:flex-row flex-col lg:px-2 px-0'>
                        <img className="left" src="pattern-1.png" alt=""/>
                        <img className="right" src="/banner.png" alt=""/>
                    </div>
                </section>

                <section className="disclaimer-sec dpage">
                    <div className="container mx-auto sm:px-4">
                        <div className="flex flex-wrap ">
                            <div className="md:w-3/4 pr-4 pl-4 mx-auto">
                                <div className="about-disclaimer">
                                    <h3>Shipping Policy</h3>

                                    <div className="middleOpening">
                                        <div className="container mx-auto sm:px-4">
                                            <div className="accordinSection">
                                                <h4>Shipment processing time</h4>
                                                <p>All orders are processed within 24 Hrs after Invoice generate.</p>
                                                <h4>Estimated Time of Delivery (ETD)</h4>
                                                <p>ETD must be mentioned as per location in the shipment process.</p>
                                                <h4>Shipment confirmation and order tracking</h4>
                                                <p>With LR details customer should know when they will receive a shipment, how to track their
                                                    shipment.</p>
                                                <h4>Damages/Short supply</h4>
                                                <p>To inform customer about Damage/Short supply policy so that it will help to settle the claims
                                                    on fastest mode, like remarks on POD, Photos of damaged goods etc.</p>
                                                <h4>Damage Material Returns</h4>
                                                <p>To inform customer how to start the damaged material return process, where they should
                                                    send the return material Include information on how long it will take to process and how they
                                                    received return claim amount.</p>

                                            </div>
                                            <section className="clear"></section>
                                        </div>
                                    </div>
                                    <div className="clear"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div>
                <footer
                    className="text-center text-lg-start text-white"
                    style={{backgroundColor: "#45526e"}}
                >
                    <div className="container mx-auto sm:px-4 p-6 pb-0">
                        <section className="">
                            <div className="flex flex-wrap ">


                                <hr className="w-full clearfix md:hidden" />


                                <hr className="w-full clearfix md:hidden" />

                                <div className="md:w-1/4 pr-4 pl-4 lg:w-1/5 pr-4 pl-4 xl:w-1/5 pr-4 pl-4 mx-auto mt-3">

                                    <p>
                                        <a className="text-white" href="/terms-and-conditions">Terms & Conditions</a>
                                    </p>
                                    <p>
                                        <a className="text-white" href="/privacy-policy">Privacy Policy</a>
                                    </p>                                    <p>
                                        <a className="text-white" href="/return-policy">Refund And Cancellation Policy</a>
                                    </p>                                    <p>
                                        <a className="text-white" href="/shipping-policy">Shipping Policy</a>
                                    </p>                                    <p>
                                        <a className="text-white" href="/pricing-policy">Pricing Policy</a>
                                    </p>

                                </div>

                                <hr className="w-full clearfix md:hidden" />

                            </div>
                        </section>

                        <hr className="my-3" />

                        <section className="p-6 pt-0">

                        </section>
                    </div>
                </footer>
            </div>
        </div>
    );
}

export default ShippingPolicy;
